
<script setup>

  import { ref } from 'vue';

  import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle, DialogDescription } from '@headlessui/vue';

  import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid';

  const isOpen = ref( false );

  const promise = ref( null );

  let promiseResolve, promiseReject;

  function open() {
    
    isOpen.value = true;

    return promise.value = new Promise( ( resolve, reject ) => {

      promiseResolve = resolve;

      promiseReject = reject;

    } );

  }

  function close() {
    
    isOpen.value = false;

    if ( promiseResolve ) promiseResolve();

  }

  defineExpose( { open, close } );

</script>

<template>

  <TransitionRoot appear :show="isOpen" as="template">

    <Dialog as="div" class="relative z-20">

      <TransitionChild

        as="template"

        enter="transition-opacity duration-300 ease-out"

        enter-from="opacity-0"

        enter-to="opacity-100"

        leave="transition-opacity duration-200 ease-in"

        leave-from="opacity-100"

        leave-to="opacity-0">

        <div class="fixed inset-0 bg-black bg-opacity-75" />

      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">

        <div class="flex min-h-full items-center justify-center p-6 drop-shadow-[0_0_15px_rgba(0,0,0,1)]">

          <TransitionChild

            as="template"

            enter="transition transform duration-300 ease-out"

            enter-from="opacity-0 scale-95"

            enter-to="opacity-100 scale-100"

            leave="transition transform duration-200 ease-in"

            leave-from="opacity-100 scale-100"

            leave-to="opacity-0 scale-95">

            <DialogPanel class="w-full max-w-xl bg-white overflow-hidden transition">
              
              <DialogTitle class="flex items-center p-4 bg-neutral-100">

                <ExclamationTriangleIcon class="w-9 text-red-600" />

                <div class="ml-4 uppercase text-xl font-bold">How to Save Your Work</div>

              </DialogTitle>

              <div class="px-12 py-8">

                <DialogDescription class="leading-7 text-neutral-700">

                  <strong class="uppercase">Important:</strong>

                  Your work in this activity is not automatically being saved.

                  To save your work, you must first complete all sections and then download your final activity file to your computer or device.

                </DialogDescription>

                <button
                
                  type="button" @click="close"
                
                  class="flex items-center gap-4 px-6 py-4 mt-12 ml-auto text-white font-bold text-white bg-green-700 transition-colors
                  
                    hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline">

                  <span>I understand</span>

                </button>

              </div>

            </DialogPanel>

          </TransitionChild>

        </div>

      </div>

    </Dialog>

  </TransitionRoot>

</template>
